import { CaretRightIcon } from "@phosphor-icons/react";

import { Text } from "@alpacahq/ui/old";

interface TransferTypeButtonProps {
  label: string;
  onClick: () => void;
}

export const TransferTypeButton = ({
  label,
  onClick,
}: TransferTypeButtonProps) => (
  <button
    onClick={onClick}
    type="button"
    className="flex w-full cursor-pointer items-center justify-between rounded border border-gray-200 px-6 py-4 transition-colors hover:border-gray-400"
  >
    <Text className="font-medium text-gray-800">{label}</Text>
    <CaretRightIcon size={20} className="text-gray-800" />
  </button>
);
